<script>
import VButton from './VButton.vue';
import VButtonIcon from './VButtonIcon.vue';
import IconShare from '../icons/share.svg'
import IconMail from '../icons/mail.svg'
import IconFacebook from '../icons/facebook.svg'
import IconLinkedIn from '../icons/linkedin.svg'
import IconCopy from '../icons/copy.svg'

export default {
    mounted() {
        const encodedUrl = encodeURIComponent(window.location);
        this.dialog = document.getElementById('share-dialog');
        this.urlInput = document.getElementById('url-input');
        this.parsedLabels = JSON.parse(this.labels);
        this.mailtoUrl = `mailto: ?subject=:&body=${'Your friend shared this page: ' + window.location }`;
        this.facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&amp;src=sdkpreparse`;
        this.linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
    },
    data() {
        return {
            mailtoUrl: '',
            facebookUrl: '',
            linkedInUrl: '',
            parsedLabels: {},
            copyMessageActive: false,
        };
    },
    props: {
        labels: String,
        dark: Boolean,
    },
    components: {
        VButton,
        VButtonIcon,
        IconShare,
        IconMail,
        IconFacebook,
        IconLinkedIn,
        IconCopy,
    },
    methods: {
        openDialog() {
            this.dialog.showModal();
            this.urlInput.value = window.location;
        },
        closeDialog() {
            this.dialog.close();
        },
        copyToClipboard() {
            try {
                navigator.clipboard.writeText(window.location);
            } catch (err) {
                console.log('Copy only works on secure origin');
            }

            this.copyMessageActive = true;
            setTimeout(() => {
                this.copyMessageActive = false;
            }, 1000);
        }
    },
};
</script>

<template>
    <div class="share">
        <VButton @buttonClick="openDialog">
            <IconShare />
            {{parsedLabels.title}}
        </VButton>
        <dialog class="share__dialog" id="share-dialog">
            <button class="share__dialog-close" @click="closeDialog()">&times;</button>
            <div class="share__dialog-content">
                <h2 class="share__title h2">{{parsedLabels.dialog_title}}</h2>
                <div class="share__links">
                    <VButtonIcon :href="mailtoUrl" :dark=true>
                        <IconMail />
                    </VButtonIcon>
                    <VButtonIcon :href="facebookUrl" :dark=true>
                        <IconFacebook />
                    </VButtonIcon>
                    <VButtonIcon :href="linkedInUrl" :dark=true>
                        <IconLinkedIn />
                    </VButtonIcon>
                </div>
                <input class="share__url" type="text" id="url-input" readonly>
                <VButton @buttonClick="copyToClipboard" :dark=true :gradient=true>
                    <IconCopy :style="{filter: 'invert(1)'}" />
                    {{parsedLabels.copy}}
                </VButton>
                <span class="share__copy-message" v-bind:class="{'share__copy-message--active': copyMessageActive}" id="copy-message">
                    {{parsedLabels.copy_message}}
                </span>
            </div>
        </dialog>
    </div>
</template>

<style lang="scss" scoped>
.share {
    &__title {
        margin-bottom: 24px;
    }

    &__dialog {
        position: fixed;
        width: 90svw;
        max-width: 800px;
        padding: 40px;
        border: 1px solid;
        border-image-source: linear-gradient(113.59deg,#ffffffb0 7.33%,#fff3f880 33.87%,#fff0 50.55%,#ffffff26 72.97%,#ffffff80 99.02%);
        border-image-slice: 1;
        background: linear-gradient(
            119.68deg,
            rgba(67, 67, 67, 0.9) 14.73%,
            rgba(24, 24, 24, 0.5) 111%
            );
        backdrop-filter: blur(10px);
        box-shadow: 0px 4px 100px rgba(0, 0, 0, 0.25);;

        &::backdrop {
            background-color: rgba(0, 0, 0, 0.3);
        }
    }

    &__dialog-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #fff;
    }

    &__links {
        display: flex;
        gap: 18px;
        margin-bottom: 36px;
    }

    &__url {
        border: 1px solid #fff;
        border-radius: 0;
        background-color: transparent;
        color: #fff;
        height: 56px;
        padding-left: 16px;
        margin-bottom: 24px;
        font-size: 1.6rem;
        width: 100%;

        &:focus {
            outline: 1px solid #fff;
            box-shadow: none;
        }
    }

    &__copy-url {
        opacity: 0;
        pointer-events: none;
        height: 0;
    }

    &__copy-message {
        display: block;
        font-size: 1rem;
        margin-top: 8px;
        height: 0;
        opacity: 0;
        transition: opacity 200ms;

        &--active {
            opacity: 1;
        }
    }

    &__dialog-close {
        outline: none;
        position: absolute;
        top: 5px;
        right: 15px;
        color: #fff;
        font-size: 3rem;
    }
}
</style>
